import { REALTIME_APP_RELEASE_CHANNEL } from "@birdwatch/common";
import { useIsMutating } from "@tanstack/react-query";
import { useEffect } from "react";
import { env } from "@/env";
import { useRealtimeRelay } from "@/features/shared/realtime-relay";
import { releasedWebappEnv } from "./released-app-env";
import { useAppVersionStore } from "./use-app-version-store";

/**
 * Arms the passive update when the platform announces a successful deploy of this app
 * and this environment (`app.released` on the public release channel), and mirrors the
 * in-flight mutation count into the store so the next-navigation refresh never aborts a
 * write.
 *
 * Renders nothing — the notice is `AppUpdateModal`, mounted once at the root.
 */
export function AppVersionWatcher() {
  const mutatingCount = useIsMutating();

  useRealtimeRelay({
    channels: [REALTIME_APP_RELEASE_CHANNEL],
    events: ["app.released"],
    onData: (payload) => {
      // Read through `payload`, never destructured: the union narrows on `event`.
      if (payload.event !== "app.released") return;
      if (releasedWebappEnv(payload.data) !== env.PUBLIC_ENV) return;
      useAppVersionStore.getState().actions.markUpdatePending();
    },
  });

  useEffect(() => {
    useAppVersionStore.getState().actions.setWriting(mutatingCount > 0);
  }, [mutatingCount]);

  return null;
}
